import { CSSProperties } from "react";

// Shared styling for the autocomplete result lists (competition, venue, team)
// so section headers and items render at a consistent size across all of the
// create-match autocomplete fields. 14px matches the original competition list.
export const autocompleteHeaderLabelStyle: CSSProperties = {
    fontSize: 14,
    marginTop: 5,
};

export const autocompleteItemStyle = {
    fontSize: 14,
    "--min-height": "40px",
} as CSSProperties;
